import axiosInstance from "./instance";

// Create Rider
const addRider = async (rider) => {
    const response = await axiosInstance.post('/riders', rider);
    return response.data;
}

// Get All Vendors by Status
const fetchRiders = async (page, status, limit = 15) => {
    const response = await axiosInstance.get('/riders', {
        params: {
            page,
            limit,
            status
        }
    });
    return response.data;
}

// Get Solo Order Details
const fetchRider = async (riderId) => {
    const response = await axiosInstance.get(`/riders/${riderId}`);
    return response.data;
}

// Get Rider Earning 
const getEarning = async (riderId, startDate, endDate) => {
    const response = await axiosInstance.get(`/riders/${riderId}/earnings`, {
        params: {
            startDate,
            endDate
        }
    });
    return response.data;
}

const updateRiderProfile = async (riderId, rider) => {
    const response = await axiosInstance.patch(`/riders/${riderId}/profile`, rider);
    return response.data;
}

const updateRiderStatus = async (riderId, status) => {
    const response = await axiosInstance.patch(`/riders/${riderId}/status`, {
        status
    });
    return response.data;

}

const updateRider = updateRiderStatus;

const deleteRider = async (riderId) => {
    const response = await axiosInstance.delete(`/riders/${riderId}`);
    return response.data;
}

const fetchDashboardRiders = async () => {
    const response = await axiosInstance.get('/dashboard/riders');
    return response.data;
}

export { addRider, fetchRiders, fetchRider, updateRider, updateRiderProfile, deleteRider, fetchDashboardRiders, getEarning };
